import React, { useContext, useEffect } from "react";
import { Grid, Paper, AppBar, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
// import Moment from "moment";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

// Components
import Overview_Header from "./Stats_01";
import Campaign_Stats from "./Stats_02";
import Adset_Stats from "./Stats_03";
import Ad_Stats from "./Stats_04";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: "8px",
  },
  appbar: {
    zIndex: "auto",
  },
  tab: {
    "&:focus": {
      outline: "none",
    },
  },
  tabPanel: {
    padding: 0,
    paddingTop: "0.3rem",
    width: "100%",
    height: 493,
  },
}));

const DashboardStats = () => {
  const classes = useStyles();

  const {
    selected_profile,
    selected_fb_details,
    stats_date_filter,
    stats_delivery_filter,
    getCampaignStats,
    getAdSetStats,
    getAdStats,
    current_tab,
    setCurrentTab,
  } = useContext(FacebookProfilesDashboardContext);

  const tabs = ["Campaign", "Ad Set", "Ad"];

  // const [current_tab, setCurrentTab] = useState("Campaign");
  const changeTab = (e, tab_name) => setCurrentTab(tab_name);

  useEffect(() => {
    // const date = new Date();
    // let newDate = Moment(date, "YYYY-MM-DD");
    // newDate = newDate.format();
    // newDate = newDate.substring(0, newDate.indexOf("T"));

    // const start_date = newDate;
    // const end_date = newDate;
    // getCampaignStats(selected_profile, start_date, end_date);

    const list = ["Campaign", "Ad Set", "Ad"];

    if (list.includes(current_tab)) {
      getCampaignStats(selected_profile);
      getAdSetStats(selected_profile);
      getAdStats(selected_profile);
    }

    //   console.log(selected_fb_details.ad_account);
    //   console.log(selected_profile.ad_set);
    // } else if (current_tab == "Ad") {
    //   console.log(selected_fb_details.ad_account);
    //   console.log(selected_profile.ad);
  }, [
    selected_fb_details,
    current_tab,
    stats_date_filter,
    stats_delivery_filter,
  ]);

  return (
    <Paper className={classes.paper}>
      <Grid container>
        <TabContext value={current_tab}>
          <AppBar position="static" color="default" className={classes.appbar}>
            <TabList
              variant="fullWidth"
              textColor="primary"
              indicatorColor="primary"
              onChange={changeTab}
            >
              {tabs.map((tab) => (
                <Tab
                  key={tab}
                  label={tab}
                  value={tab}
                  className={classes.tab}
                />
              ))}{" "}
            </TabList>{" "}
          </AppBar>
          <TabPanel value={current_tab} className={classes.tabPanel}>
            <Overview_Header />
            {current_tab === "Campaign" && <Campaign_Stats />}{" "}
            {current_tab === "Ad Set" && <Adset_Stats />}{" "}
            {current_tab === "Ad" && <Ad_Stats />}{" "}
          </TabPanel>{" "}
        </TabContext>{" "}
      </Grid>{" "}
    </Paper>
  );
};

export default DashboardStats;
